import { render } from "./topheader.vue?vue&type=template&id=0271af26&scoped=true"
import script from "./topheader.vue?vue&type=script&lang=js"
export * from "./topheader.vue?vue&type=script&lang=js"

import "./topheader.vue?vue&type=style&index=0&id=0271af26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0271af26"]])

export default __exports__